export default "__VITE_ASSET__CmGa_QN5__"